import { render, staticRenderFns } from "./readTextView.vue?vue&type=template&id=3eb3defc&scoped=true"
import script from "./readTextView.vue?vue&type=script&lang=js"
export * from "./readTextView.vue?vue&type=script&lang=js"
import style0 from "./readTextView.vue?vue&type=style&index=0&id=3eb3defc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb3defc",
  null
  
)

export default component.exports